var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarSuppliers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.00002C7.25 6.24266 6.24264 7.25 5 7.25C3.75736 7.25 2.75 6.24266 2.75 5.00002C2.75 3.75737 3.75738 2.75 5 2.75C6.24263 2.75 7.25 3.75737 7.25 5.00002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24995 17C7.24995 18.2427 6.24261 19.25 4.99997 19.25C3.75734 19.25 2.75 18.2427 2.75 17C2.75 15.7574 3.75735 14.75 4.99997 14.75C6.2426 14.75 7.24995 15.7574 7.24995 17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 17C19.2499 18.2427 18.2426 19.25 17 19.25C15.7573 19.25 14.75 18.2427 14.75 17C14.75 15.7574 15.7574 14.75 17 14.75C18.2426 14.75 19.2499 15.7574 19.2499 17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5.41432 9.49289 6.88744 10.6019 8.62146 10.5876L11.7826 10.5735C14.1918 10.5592 16.2481 11.9953 17 14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSuppliers);
export default __webpack_public_path__ + "static/media/sidebar-suppliers.381cb0e4.svg";
export { ForwardRef as ReactComponent };